import React, { useEffect, useState } from "react";

const BookingList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const res = await fetch("https://api.getfitindia.in/api/users", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();

        if (Array.isArray(data)) {
          setUsers(data);
        } else if (data.users && Array.isArray(data.users)) {
          setUsers(data.users);
        } else if (data.error) {
          console.error("Backend error:", data.error);
          setErrorMsg(data.error);
          setUsers([]);
        } else {
          console.warn("Unexpected API response:", data);
          setUsers([]);
        }
      } catch (err) {
        console.error("Failed to fetch users:", err);
        setErrorMsg("Failed to fetch users. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token]);

  const toggleBlock = async (userId) => {
    try {
      const res = await fetch(
        `https://api.getfitindia.in/api/users/${userId}/block`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      if (data.error) {
        alert(data.error);
        return;
      }

      alert(data.message);

      setUsers((prev) =>
        prev.map((u) =>
          u._id === userId ? { ...u, blocked: data.user.blocked } : u
        )
      );
    } catch (err) {
      alert("Failed to block/unblock user.");
      console.error(err);
    }
  };

  // 🔔 fire a global event so AdminLayout can open sidebar
  const openSidebar = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("admin-open-sidebar"));
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6FB] flex flex-col">
      {/* 🔵 Top bar */}
      {/* HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl  px-4 py-4">
       <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
 All Registered Users
</h1>

        </div>
      </div>

      {/* Page content */}
      <div className="px-4 md:px-6 lg:px-10 py-6 flex-1 overflow-x-hidden overflow-y-auto">
        {/* 🔻 Removed card box / border, just plain layout */}
        <div className="w-full">
          {/* Optional strip (no border box) */}
          <div className="px-2 md:px-0 mb-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-[#0C295F]">
              Users List
            </span>
            <span className="text-xs md:text-sm text-gray-500">
              Total: {users.length}
            </span>
          </div>

          <div className="bg-white rounded-xl p-3 md:p-4 overflow-x-auto shadow-[0_0_6px_rgba(0,0,0,0.2)]">
            {loading && (
              <p className="text-sm text-gray-500">Loading users...</p>
            )}

            {errorMsg && (
              <p className="text-sm text-red-500 mb-4">{errorMsg}</p>
            )}

            {!loading && !errorMsg && users.length === 0 && (
              <p className="text-sm text-red-500">No users found.</p>
            )}

            {!loading && !errorMsg && users.length > 0 && (
              <table className="min-w-full bg-white text-sm">
                <thead className="bg-[#c4d5f1] text-[#0C295F]">
                  <tr>
                    <th className="px-4 py-3 border-b text-left">#</th>
                    <th className="px-4 py-3 border-b text-left">Name</th>
                    <th className="px-4 py-3 border-b text-left">Mobile</th>
                    <th className="px-4 py-3 border-b text-left">Gender</th>
                    <th className="px-4 py-3 border-b text-left">City</th>
                    <th className="px-4 py-3 border-b text-left">
                      Joined Date
                    </th>
                    <th className="px-4 py-3 border-b text-left">Block</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, idx) => (
                    <tr
                      key={user._id || idx}
                      className="odd:bg-white even:bg-[#F9FBFF] hover:bg-[#EEF3FF] transition-colors"
                    >
                      <td className="px-4 py-3 border-b">{idx + 1}</td>
                      <td className="px-4 py-3 border-b capitalize">
                        {user.name || "N/A"}
                      </td>
                      <td className="px-4 py-3 border-b">
                        {user.mobile || "N/A"}
                      </td>
                      <td className="px-4 py-3 border-b">
                        {user.gender || "N/A"}
                      </td>
                      <td className="px-4 py-3 border-b">
                        {user.city || "N/A"}
                      </td>
                      <td className="px-4 py-3 border-b">
                        {user.createdAt?.split("T")[0] || "N/A"}
                      </td>
                      <td className="px-4 py-3 border-b">
                        <button
                          className={`px-3 py-1 rounded-full text-xs font-semibold shadow-sm transition-colors ${
                            user.blocked
                              ? "bg-red-600 hover:bg-red-700 text-white"
                              : "bg-[#0C295F] hover:bg-[#071833] text-white"
                          }`}
                          onClick={() => toggleBlock(user._id)}
                        >
                          {user.blocked ? "Unblock" : "Block"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingList;

